import { OrderFailedResult, OrderResultWithPendingStatus } from 'components/features/rewards/rewardsPane/types/orderResult'
import { OrdersResultsReducer } from 'components/features/rewards/rewardsPane/types/store'
import { PreviewOrderFailedResult, PreviewOrderResultWithStatus } from 'components/features/rewards/rewardsPane/types/orderPreviewResult'
import { State } from 'interfaces/state'
import { getPaneReducerStateSelector } from 'components/features/rewards/rewardsPane/store/selectors/generalReducer'
import {
  FLOATING_PANE_AUTO_INVESTMENTS_MODE,
  FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE,
  FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE,
} from 'components/features/rewards/rewardsPane/constants/paneState'
import { CryptoRewardsPaneMode } from 'components/features/rewards/rewardsPane/types/paneState'
import { OrderSuccessResultWithMeta } from 'components/features/rewards/rewardsPane/types/orderResult'
import { GeneralError } from 'interfaces/errors'

function getOrdersResultsReducerStateSelector (storeState: State): OrdersResultsReducer<CryptoRewardsPaneMode> {
  return getPaneReducerStateSelector(storeState).ordersResults
}

export function isOrdersResultsLoadingSelector (state: State): boolean {
  return Boolean(getOrdersResultsReducerStateSelector(state)?.isLoading)
}

export function getOrderResultWithMetaDetailsSelector (storeState: State): OrderResultWithPendingStatus<CryptoRewardsPaneMode> | null {
  return getOrdersResultsReducerStateSelector(storeState).lastOrderResult || null
}

export function getOrderSuccessResultOrNullSelector (storeState: State): OrderSuccessResultWithMeta<CryptoRewardsPaneMode> | null {
  const orderResultState = getOrderResultWithMetaDetailsSelector(storeState)

  if (!orderResultState || orderResultState.isPending) {
    return null
  }
  return orderResultState.success || null
}


export function createGetOrderSuccessResultOrNullByModeSelector<M extends CryptoRewardsPaneMode> (mode: M) {
  return (storeState: State): OrderSuccessResultWithMeta<M> | null => {
    const orderSuccessResultOrNull = getOrderSuccessResultOrNullSelector(storeState)
    if (orderSuccessResultOrNull?.mode === mode) {
      return orderSuccessResultOrNull as OrderSuccessResultWithMeta<M>
    }
    return null
  }
}

export const getBuyOrderSuccessResultOrNullSelector = createGetOrderSuccessResultOrNullByModeSelector(FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE)

export const getSellOrderSuccessResultOrNullSelector = createGetOrderSuccessResultOrNullByModeSelector(FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE)

export const getSwitchAutoInvestmentsModeSuccessResultSelector = createGetOrderSuccessResultOrNullByModeSelector(FLOATING_PANE_AUTO_INVESTMENTS_MODE)

export function getOrderFailedResultOrNullSelector (storeState: State): OrderFailedResult<CryptoRewardsPaneMode> | null {
  const orderResultState = getOrderResultWithMetaDetailsSelector(storeState)

  if (!orderResultState || orderResultState.isPending) {
    return null
  }
  return orderResultState.errors || null
}

export function createGetOrderFailedResultOrNullByModeSelector<M extends CryptoRewardsPaneMode> (mode: M) {
  return (storeState: State): OrderFailedResult<M> | null => {
    const orderResultState = getOrderResultWithMetaDetailsSelector(storeState)
    if (!orderResultState?.isPending && orderResultState?.errors && orderResultState?.mode === mode) {
      return orderResultState?.errors as OrderFailedResult<M>
    }
    return null
  }
}

export const getBuyOrderFailedResultOrNullSelector = createGetOrderFailedResultOrNullByModeSelector(FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE)

export const getSellOrderFailedResultOrNullSelector = createGetOrderFailedResultOrNullByModeSelector(FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE)

export const getChangeAutoInvestmentsModeFailedResultSelector = createGetOrderFailedResultOrNullByModeSelector(FLOATING_PANE_AUTO_INVESTMENTS_MODE)


export function getOrderPreviewOrNullSelector (storeState: State): PreviewOrderResultWithStatus | null {
  return getOrdersResultsReducerStateSelector(storeState).lastOrderPreviewResult || null
}
export function createGetPreviewOrderFailedResultOrNullSelector () {
  return (storeState: State): PreviewOrderFailedResult | null => {
    const orderResultState = getOrderPreviewOrNullSelector(storeState)
    if (!orderResultState?.isPending && orderResultState?.errors) {
      return orderResultState?.errors
    }
    return null
  }
}

export const getSellPreviewOrderFailedResultOrNullSelector = createGetPreviewOrderFailedResultOrNullSelector()

export function getOrdersHistoryLoadingErrorsOrNullSelector (state: State): GeneralError[] | null {
  return getOrdersResultsReducerStateSelector(state).ordersHistoryLoadingErrors ?? null
}
